import React from "react";
import useUsuariosLogic from "./hooks/useUsuariosLogic";
import UsuariosView from "./pages/UsuariosView.jsx";

export default function Usuarios() {
    const logic = useUsuariosLogic();
    return <UsuariosView {...logic} />;
}
